import React, { useEffect, useContext, useMemo } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { UserContext } from '../../Contexts/UserContext';
import VideoLibrary from './VideoLibrary';
import Admin from './Admin';
import SuperAdmin from './SuperAdmin/SuperAdmin';
import BannerFpSiteSearch from './BannerFpSiteSearch';
import SplitDocSearch from './SplitDocSearch';
import CheckBoxOutlineBlankRoundedIcon from '@mui/icons-material/CheckBoxOutlineBlankRounded';
import PieChartIcon from '@mui/icons-material/PieChart';
import LayersIcon from '@mui/icons-material/Layers';
import Sidebar from './Sidebar';
import PublicIcon from '@mui/icons-material/Public';

//mui imports====
import { Box } from '@mui/system';
import { Typography } from '@mui/material';
import useStyles from './styles';
import SlowMotionVideoIcon from '@mui/icons-material/SlowMotionVideo';
import VideoLibraryIcon from '@mui/icons-material/VideoLibrary';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import Modalv2 from '../../Components/Modalv2';
import FvpSiteSearch from './FvpSiteSearch';
import { ACCESS_CONTROL_CONSTANTS, DASHBOARD_PANELS } from '../../core/constants';
import NetworkWideSync from './NetworkWideSync';
import { ExploreOutlined } from '@mui/icons-material';
import ExperimentTable from './Components/ExperimentTable/ExperimentTable';
//===============

const { ACCESS_CONTROL_STRINGS } = ACCESS_CONTROL_CONSTANTS;
const Dashboard = () => {
	const { user } = useContext(UserContext);
	const navigate = useNavigate();
	const [searchParams, setSearchParams] = useSearchParams();
	const requestedPanel = searchParams.get('panel');
	const classes = useStyles();
	const userHasFvpReadWriteAccess = user?.controlledAccess?.includes(
		ACCESS_CONTROL_STRINGS.FVP_READ_WRITE
	);

	const userHasExperimentOverviewReadAccess = user?.controlledAccess?.includes(
		ACCESS_CONTROL_STRINGS.EXPERIMENT_OVERVIEW_READ
	);

	const componentsList = useMemo(() => {
		const initialList = {};

		if (user?.hasInstreamAccess) {
			initialList[DASHBOARD_PANELS.ADMIN] = {
				label: 'Framerate',
				component: <Admin />,
				icon: <SlowMotionVideoIcon />
			};
			initialList[DASHBOARD_PANELS.VIDEO_LIBRARY] = {
				label: 'Video Library',
				component: <VideoLibrary />,
				icon: <VideoLibraryIcon />
			};
		}

		if (userHasExperimentOverviewReadAccess) {
			initialList[DASHBOARD_PANELS.EXPERIMENT] = {
				label: 'Experiments',
				component: <ExperimentTable />,
				icon: <ExploreOutlined />
			};
		}

		if (user?.isSuperAdmin && user?.isAdmin) {
			initialList[DASHBOARD_PANELS.NETWORK_WIDE_SYNC] = {
				label: 'Network Wide Sync',
				component: <NetworkWideSync />,
				icon: <PublicIcon />
			};
		}

		if (user?.isSuperAdmin && user?.isAdmin) {
			initialList[DASHBOARD_PANELS.SUPER_ADMIN] = {
				label: 'Super Admin',
				component: <SuperAdmin />,
				icon: <SupervisorAccountIcon />
			};
		}
		if (user?.hasBannerFpAccess) {
			initialList[DASHBOARD_PANELS.BANNER_FP] = {
				label: 'Banner Fp Engine',
				component: <BannerFpSiteSearch />,
				icon: <CheckBoxOutlineBlankRoundedIcon style={{ marginTop: '.4rem' }} />
			};
		}

		if (user?.hasSplitDocAccess) {
			initialList[DASHBOARD_PANELS.SPLIT_DOC_EDITOR] = {
				label: 'Script Split Editor',
				component: <SplitDocSearch />,
				icon: <PieChartIcon style={{ marginTop: '.4rem' }} />
			};
		}

		if (userHasFvpReadWriteAccess) {
			initialList[DASHBOARD_PANELS.FVP_CONFIG_EDITOR] = {
				label: 'Fvp Config Editor',
				component: <FvpSiteSearch />,
				icon: <LayersIcon style={{ marginTop: '.4rem' }} />
			};
		}
		return initialList;
	}, [user]);

	const panelNames = Object.keys(componentsList);
	const selected = panelNames.includes(requestedPanel)
		? requestedPanel
		: panelNames[0] || '';

	const handlePanelChange = (panel) => {
		setSearchParams({ panel });
	};

	useEffect(() => {
		if (!user) navigate('/login');
	});

	return (
		<Box className={classes.dashboardPage}>
			{panelNames.length > 0 ? (
				<>
					<Sidebar
						selected={selected}
						setSelected={handlePanelChange}
						componentsList={componentsList}
					/>
					{componentsList[selected]?.component}
					<Modalv2 />
				</>
			) : (
				<Typography variant="h5" style={{ color: 'black', textAlign: 'center', marginTop: '20px' }}>
					You do not have access to any dashboard components. <br /> Please contact Adpushup
					support.
				</Typography>
			)}
		</Box>
	);
};

export default Dashboard;
